import React, { useEffect, useState, useRef } from "react";
import { BASE_URL } from "../../config/axios";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import { ToastContainer, toast } from "react-toastify";
import { handleErrorToast } from "../CustomFunctions";
import * as XLSX from "xlsx";
import Select from "react-select";
import {
  AddwithWhiteCircle,
  DeleteDustbin,
  UpdatePencil,
} from "../AllSvg";
import AimantraLoading from "../AimantraLoading/AimantraLoading";

// ─── Inline styles (BidGrid token system) ─────────────────────────────────────
const S = {
  // Root wrapper
  root: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    background: "#ffffff",
    overflow: "hidden",
    fontFamily: '"Segoe UI", -apple-system, BlinkMacSystemFont, sans-serif',
    fontSize: "12px",
    color: "#1a1a2e",
  },

  // Top bar
  topbar: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "0 12px",
    background: "#f6f8fa",
    borderBottom: "1px solid #d0d7de",
    minHeight: "44px",
    flexWrap: "wrap",
  },
  topbarBrand: {
    fontSize: "15px",
    fontWeight: 700,
    color: "#185fa5",
    letterSpacing: "-0.3px",
    marginRight: "8px",
    whiteSpace: "nowrap",
  },
  topbarActions: {
    display: "flex",
    gap: "4px",
    marginLeft: "auto",
  },

  // Buttons
  iconBtn: {
    height: "30px",
    padding: "0 10px",
    fontSize: "11.5px",
    fontWeight: 600,
    background: "#185fa5",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "5px",
    whiteSpace: "nowrap",
    transition: "background 0.15s",
  },
  iconBtnOutline: {
    height: "30px",
    padding: "0 10px",
    fontSize: "11.5px",
    fontWeight: 600,
    background: "#fff",
    color: "#185fa5",
    border: "1px solid #185fa5",
    borderRadius: "5px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "5px",
    whiteSpace: "nowrap",
  },

  // Tab bar
  tabbar: {
    display: "flex",
    alignItems: "stretch",
    gap: 0,
    overflowX: "auto",
    background: "#f6f8fa",
    borderBottom: "1px solid #d0d7de",
    minHeight: "42px",
  },
  tab: (active) => ({
    display: "flex",
    alignItems: "center",
    gap: "5px",
    padding: "0 18px",
    height: "40px",
    fontSize: "11.5px",
    fontWeight: active ? 700 : 500,
    color: active ? "#185fa5" : "#57606a",
    background: active ? "rgba(24,95,165,0.06)" : "transparent",
    border: "none",
    borderBottom: active ? "2px solid #185fa5" : "2px solid transparent",
    cursor: "pointer",
    whiteSpace: "nowrap",
    transition: "all 0.15s",
  }),

  // Filter bar
  filterbar: {
    display: "flex",
    alignItems: "flex-end",
    gap: "8px",
    padding: "8px 12px",
    background: "#f6f8fa",
    borderBottom: "1px solid #d0d7de",
    flexWrap: "wrap",
  },
  filterGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "3px",
  },
  filterLabel: {
    fontSize: "10.5px",
    fontWeight: 700,
    color: "#185fa5",
    letterSpacing: "0.2px",
    textTransform: "uppercase",
  },
  filterInput: {
    height: "30px",
    padding: "0 10px",
    border: "1px solid #d0d7de",
    borderRadius: "4px",
    fontSize: "11.5px",
    background: "#fff",
    color: "#1a1a2e",
    width: "180px",
    outline: "none",
  },
  filterSelect: {
    height: "30px",
    padding: "0 8px",
    border: "1px solid #d0d7de",
    borderRadius: "4px",
    fontSize: "11.5px",
    background: "#fff",
    color: "#1a1a2e",
    cursor: "pointer",
    outline: "none",
    width: "150px",
  },
  filterActions: {
    display: "flex",
    gap: "4px",
    alignSelf: "flex-end",
    marginLeft: "auto",
  },
  filterBtn: (primary) => ({
    height: "30px",
    padding: "0 14px",
    fontSize: "11.5px",
    fontWeight: 600,
    borderRadius: "4px",
    cursor: "pointer",
    border: primary ? "none" : "1px solid #d0d7de",
    background: primary ? "#185fa5" : "#fff",
    color: primary ? "#fff" : "#57606a",
    transition: "all 0.15s",
  }),

  // Table scroll
  tableScroll: {
    overflowX: "auto",
    overflowY: "auto",
    flex: "1 1 auto",
    minHeight: "380px",
  },

  // Table
  table: {
    width: "100%",
    borderCollapse: "collapse",
    tableLayout: "fixed",
    minWidth: "1100px",
  },

  // TH
  th: (center) => ({
    padding: "7px 10px",
    textAlign: center ? "center" : "left",
    fontSize: "10.5px",
    fontWeight: 700,
    color: "#fff",
    background: "#185fa5",
    borderRight: "1px solid rgba(255,255,255,0.18)",
    whiteSpace: "nowrap",
    position: "sticky",
    top: 0,
    zIndex: 4,
    textTransform: "uppercase",
    letterSpacing: "0.3px",
  }),

  // TD
  td: (center) => ({
    padding: "6px 10px",
    fontSize: "11px",
    color: "#1a1a2e",
    borderRight: "1px solid #e8ecf0",
    verticalAlign: "middle",
    whiteSpace: "normal",
    wordBreak: "break-word",
    textAlign: center ? "center" : "left",
  }),

  // Row
  row: (even) => ({
    borderBottom: "1px solid #e8ecf0",
    cursor: "default",
    background: even ? "#f8fafd" : "#ffffff",
    transition: "background 0.1s",
  }),

  // Actions cell
  rowActions: {
    display: "flex",
    justifyContent: "center",
    gap: "4px",
    alignItems: "center",
  },
  actionBtn: {
    height: "24px",
    minWidth: "24px",
    padding: "0 6px",
    fontSize: "11px",
    border: "1px solid #d0d7de",
    borderRadius: "4px",
    background: "#fff",
    color: "#57606a",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.12s",
  },

  // Status bar
  statusbar: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "5px 14px",
    background: "#f6f8fa",
    borderTop: "1px solid #d0d7de",
    fontSize: "10.5px",
    color: "#57606a",
    flexShrink: 0,
  },

  // Sector badge
  sectorBadge: {
    display: "inline-block",
    padding: "2px 6px",
    borderRadius: "3px",
    fontSize: "10px",
    fontWeight: 600,
    background: "#deeeff",
    color: "#185fa5",
    whiteSpace: "normal",
    margin: "1px",
  },

  // Empty
  emptyRow: {
    textAlign: "center",
    padding: "40px",
    color: "#57606a",
    fontSize: "12px",
    fontStyle: "italic",
  },

  // Loader
  loaderWrap: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "40px",
    color: "#185fa5",
    fontSize: "12px",
    fontStyle: "italic",
  },
};

// ─── Shared sector options ─────────────────────────────────────────────────────
const SECTOR_OPTIONS = [
  { value: "Highway", label: "Highway" },
  { value: "Railway", label: "Railway" },
  { value: "Metro", label: "Metro" },
  { value: "Water", label: "Water" },
  { value: "Ropeway", label: "Ropeway" },
  { value: "Building", label: "Building" },
  { value: "Other", label: "Other" },
];

// ─── Partner Form (shared by Add/Update) ──────────────────────────────────────
const PartnerFormBody = ({ formData, errors, handleInputChange }) => (
  <div className="form-flex-wrap">
    <div className="flex-column">
      <label className="form-labels font-weight500 font-size-heading">Priority Order</label>
      <input type="text" name="priority_order" placeholder="Priority Order"
        value={formData.priority_order} onChange={handleInputChange}
        className="form-input font-weight400 font-size-subheading form-input-background" />
    </div>

    <div className="flex-column">
      <label className="form-labels font-weight500 font-size-heading">Partner Name <span className="required">*</span></label>
      <input type="text" name="partner_name" placeholder="Partner Name"
        value={formData.partner_name} onChange={handleInputChange}
        className={`form-input font-weight400 font-size-subheading form-input-background ${errors.partner_name ? "error" : ""}`} />
      {errors.partner_name && <span className="error-message font-size-text">{errors.partner_name}</span>}
    </div>

    <div className="flex-column form-group-selectt" style={{ display: "block" }}>
      <label className="form-labels font-weight500 font-size-subheading">Sector <span className="required">*</span></label>
      <br />
      <Select
        options={SECTOR_OPTIONS} isMulti isSearchable isClearable
        value={Array.isArray(formData.sector) ? formData.sector.map(v => ({ value: v, label: v })) : []}
        onChange={opts => handleInputChange({ target: { name: "sector", value: opts ? opts.map(o => o.value) : [] } })}
        placeholder="Select Sectors" noOptionsMessage={() => "No other options"} />
      <br />
      {errors.sector && <span className="error-message">{errors.sector}</span>}
    </div>

    <div className="flex-column">
      <label className="form-labels font-weight500 font-size-heading">Ops POC</label>
      <input type="text" name="ops_poc" placeholder="Ops POC"
        value={formData.ops_poc} onChange={handleInputChange}
        className="form-input font-weight400 font-size-subheading form-input-background" />
    </div>

    <div className="flex-column">
      <label className="form-labels font-weight500 font-size-heading">Email Id <span className="required">*</span></label>
      <input type="email" name="email" placeholder="Email Id"
        value={formData.email} onChange={handleInputChange}
        className="form-input font-weight400 font-size-subheading form-input-background" />
      {errors.email && <span className="error-message font-size-text">{errors.email}</span>}
    </div>

    <div className="flex-column">
      <label className="form-labels font-weight500 font-size-heading">Contact No</label>
      <input type="text" name="contact_no" placeholder="Contact No."
        value={formData.contact_no} onChange={handleInputChange}
        className="form-input font-weight400 font-size-subheading form-input-background" />
    </div>

    <div className="flex-column">
      <label className="form-labels font-weight500 font-size-heading">Senior POC</label>
      <input type="text" name="senior_poc" placeholder="Senior POC"
        value={formData.senior_poc} onChange={handleInputChange}
        className="form-input font-weight400 font-size-subheading form-input-background" />
    </div>

    <div className="flex-column">
      <label className="form-labels font-weight500 font-size-heading">Senior Contact No</label>
      <input type="text" name="senior_contact_no" placeholder="Senior Contact No."
        value={formData.senior_contact_no} onChange={handleInputChange}
        className="form-input font-weight400 font-size-subheading form-input-background" />
    </div>

    <div className="flex-column">
      <label className="form-labels font-weight500 font-size-heading">Internal POC</label>
      <input type="text" name="internal_poc" placeholder="Internal POC"
        value={formData.internal_poc} onChange={handleInputChange}
        className="form-input font-weight400 font-size-subheading form-input-background" />
    </div>

    <div className="flex-column">
      <label className="form-labels font-weight500 font-size-heading">TnCs</label>
      <textarea name="tncs" placeholder="Terms and Conditions" rows={2}
        value={formData.tncs} onChange={handleInputChange}
        className="form-input font-weight400 font-size-subheading form-input-background" />
    </div>

    <div className="flex-column">
      <label className="form-labels font-weight500 font-size-heading">Remark</label>
      <textarea name="remark" placeholder="Remark" rows={2}
        value={formData.remark} onChange={handleInputChange}
        className="form-input font-weight400 font-size-subheading form-input-background" />
    </div>
  </div>
);

const EMPTY_FORM = {
  priority_order: "", partner_name: "", sector: "", ops_poc: "",
  email: "", contact_no: "", senior_poc: "", senior_contact_no: "",
  internal_poc: "", tncs: "", remark: "",
};

// ─── Add Modal ────────────────────────────────────────────────────────────────
const AddPartnerModal = ({ title, apiUrl, getJvPartner, JvPartnerData }) => {
  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState(EMPTY_FORM);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleClose = () => { setFormData(EMPTY_FORM); setErrors({}); setShow(false); };
  const handleShow = () => {
    setFormData(prev => ({ ...EMPTY_FORM, priority_order: (JvPartnerData?.length || 0) + 1 }));
    setShow(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: typeof value === "string" ? value.trim() : value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    const newErrors = {};
    ["partner_name", "sector", "email"].forEach(f => { if (!formData[f]) newErrors[f] = `${f.charAt(0).toUpperCase() + f.slice(1)} is required!`; });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    const tid = toast.loading("Loading: Please wait...");
    try {
      const res = await axios.post(apiUrl, formData);
      if (res.status === 200 || res.status === 201) {
        await getJvPartner(); handleClose();
        toast.dismiss(tid); toast.success(`${title} added successfully!`);
      } else { toast.dismiss(tid); toast.error(`Failed to add ${title}!`); }
    } catch (err) { handleErrorToast(err); }
    finally { setLoading(false); toast.dismiss(tid); }
  };

  return (
    <>
      <button style={S.iconBtn} onClick={handleShow}>
        <AddwithWhiteCircle /> {title}
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
        <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
          <Modal.Title>Add {title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="register-from">
            <PartnerFormBody formData={formData} errors={errors} handleInputChange={handleInputChange} />
          </form>
          <div className="button-models">
            <button className="model-button font-weight500 model-button-cancel" onClick={handleClose}>Cancel</button>
            <button className="model-button font-weight500 model-button-leave" onClick={handleSubmit} disabled={loading}>Add</button>
          </div>
          <ToastContainer position="top-center" autoClose={1000} />
        </Modal.Body>
      </Modal>
    </>
  );
};

// ─── Update Modal ─────────────────────────────────────────────────────────────
const UpdatePartnerModal = ({ title, apiUrl, i, getJvPartner }) => {
  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState(EMPTY_FORM);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleClose = () => { setFormData(EMPTY_FORM); setErrors({}); setShow(false); };
  const handleShow = () => { setFormData(i); setShow(true); };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: typeof value === "string" ? value.trim() : value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    const newErrors = {};
    ["partner_name", "sector", "email"].forEach(f => { if (!formData[f]) newErrors[f] = `${f.charAt(0).toUpperCase() + f.slice(1)} is required!`; });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    const tid = toast.loading("Loading: Please wait...");
    try {
      const res = await axios.put(`${apiUrl}${i.id}/`, formData);
      if (res.status === 200) {
        await getJvPartner(); handleClose();
        toast.dismiss(tid); toast.success(`${title} updated successfully!`);
      } else { toast.dismiss(tid); toast.error(`Failed to update ${title}!`); }
    } catch (err) { handleErrorToast(err); }
    finally { setLoading(false); toast.dismiss(tid); }
  };

  return (
    <>
      <button title={`Edit ${title}`} className="model-edit-button" onClick={handleShow}><UpdatePencil /></button>
      <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
        <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
          <Modal.Title>Update {title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="register-from">
            <PartnerFormBody formData={formData} errors={errors} handleInputChange={handleInputChange} />
          </form>
          <div className="button-models">
            <button className="model-button font-weight500 model-button-cancel" onClick={handleClose}>Cancel</button>
            <button className="model-button font-weight500 model-button-leave" onClick={handleSubmit} disabled={loading}>Update</button>
          </div>
          <ToastContainer position="top-center" autoClose={1000} />
        </Modal.Body>
      </Modal>
    </>
  );
};

// ─── Delete Modal ─────────────────────────────────────────────────────────────
const DeletePartnerModal = ({ title, apiUrl, i, getJvPartner }) => {
  const [show, setShow] = useState(false);

  const handleDelete = async (e) => {
    e.preventDefault();
    const tid = toast.loading("Loading: Please wait...");
    try {
      const res = await axios.delete(`${apiUrl}${i.id}/`);
      if (res.status === 200 || res.status === 204) {
        await getJvPartner(); setShow(false);
        toast.dismiss(tid); toast.success(`${title} deleted successfully`);
      }
    } catch (err) { handleErrorToast(err); }
    finally { toast.dismiss(tid); }
  };

  return (
    <>
      <button title={`Delete ${title}`} className="model-delete-button" onClick={() => setShow(true)}><DeleteDustbin /></button>
      <Modal show={show} onHide={() => setShow(false)} dialogClassName="request-leave">
        <Modal.Header closeButton>
          <Modal.Title>Delete {title}: {i.partner_name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are you sure you want to delete this {title}?
            <div className="button-models">
              <button className="model-button font-weight500 model-button-cancel" onClick={() => setShow(false)}>Cancel</button>
              <button className="model-button font-weight500 model-button-delete" onClick={handleDelete}>Delete</button>
            </div>
          </div>
          <ToastContainer position="top-center" autoClose={1000} />
        </Modal.Body>
      </Modal>
    </>
  );
};

// ─── Upload Modal ─────────────────────────────────────────────────────────────
const UploadPartnerModal = ({ title, apiUrl, getJvPartner }) => {
  const [show, setShow] = useState(false);
  const [fileName, setFileName] = useState("");
  const [excelJson, setExcelJson] = useState(null);
  const [docErrors, setDocErrors] = useState({});
  const [validationErrors, setValidationErrors] = useState([]);

  const fields = ["priority_order", "partner_name", "sector", "ops_poc", "email", "contact_no", "senior_poc", "senior_contact_no", "internal_poc", "tncs", "remark"];

  const handleClose = () => { setShow(false); setFileName(""); setExcelJson(null); setDocErrors({}); setValidationErrors([]); };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setDocErrors({});
    if (!file) return;
    const valid = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
    if (!valid.includes(file.type)) { setDocErrors({ document_file: "Please upload a valid Excel file (.xlsx or .xls)." }); return; }
    setFileName(file.name);
    const reader = new FileReader();
    reader.onload = (ev) => {
      const data = new Uint8Array(ev.target.result);
      const wb = XLSX.read(data, { type: "array" });
      const ws = wb.Sheets[wb.SheetNames[0]];
      setExcelJson(XLSX.utils.sheet_to_json(ws, { defval: "" }));
    };
    reader.readAsArrayBuffer(file);
  };

  const handleUpload = async () => {
    if (!excelJson) { setDocErrors({ document_file: "Please upload a valid Excel file." }); return; }
    const errs = [];
    excelJson.forEach((row, i) => { if (!row.partner_name) errs.push(`Row ${i + 2}: Missing Partner Name`); });
    if (errs.length > 0) { setValidationErrors(errs); return; }
    setValidationErrors([]);
    const tid = toast.loading(`Uploading ${title}s...`);
    try {
      const res = await axios.post(apiUrl, excelJson);
      if (res.status === 200 || res.status === 201) { toast.success(`${title} data uploaded successfully!`); getJvPartner(); handleClose(); }
      else toast.error("Upload failed!");
    } catch (err) { toast.error("Error uploading data."); }
    finally { toast.dismiss(tid); }
  };

  const toTitle = (s) => s.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());

  return (
    <>
      <button style={S.iconBtnOutline} onClick={() => setShow(true)} title={`Upload ${title}`}>
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 22">
          <g fill="none" stroke="#185fa5" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
            <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14" />
          </g>
        </svg>
        Upload
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
        <Modal.Header closeButton>
          <Modal.Title>Upload Bulk {title} Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <button className="model-button-download model-button font-weight500" onClick={() => { const a = document.createElement("a"); a.href = "https://cipl-aimantra.s3.ap-south-1.amazonaws.com/bid/tender/26106e67-f10b-4737-aff4-08d010e1c136/tender+sheet28-10-25.xlsx"; a.download = "Template.xlsx"; a.click(); }}>
            Download Format
          </button>
          {excelJson && (
            <div className="table-css-white-background scroll-container mt-3">
              <table className="nested-table-lightblue">
                <thead><tr>{fields.map((f, i) => <th key={i}>{toTitle(f)}</th>)}</tr></thead>
                <tbody>{excelJson.map((row, i) => <tr key={i}>{fields.map((f, j) => <td key={j}>{row[f]}</td>)}</tr>)}</tbody>
              </table>
            </div>
          )}
          <div className="flex-column field-cont-div mt-3">
            <label className="form-labels font-weight500">Upload File</label>
            <input type="file" accept=".xlsx,.xls" onChange={handleFileChange} className="file-inputs align-center" />
            {fileName && <p className="file-name">{fileName}</p>}
            {docErrors.document_file && <span className="error-message">{docErrors.document_file}</span>}
          </div>
          <div className="button-models mt-3">
            <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>Cancel</button>
            <button className="model-button-download model-button font-weight500" onClick={handleUpload}>Upload</button>
          </div>
          {validationErrors.length > 0 && (
            <div style={{ background: "#ffecec", border: "1px solid #f5c2c7", color: "#842029", borderRadius: "6px", padding: "10px", marginTop: "15px", fontSize: "14px", maxHeight: "200px", overflowY: "auto" }}>
              <strong>Validation Errors:</strong>
              <ul>{validationErrors.map((e, i) => <li key={i}>{e}</li>)}</ul>
            </div>
          )}
        </Modal.Body>
        <ToastContainer position="top-center" autoClose={1000} />
      </Modal>
    </>
  );
};

// ─── Partner Table (shared by JvPartner & AssociatePartner) ───────────────────
const PartnerTable = ({ title, listApiUrl, addApiUrl, updateApiUrl, deleteApiUrl, uploadApiUrl, sectorOptions }) => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [buffer, setBuffer] = useState(true);
  const [filters, setFilters] = useState({ searchPartner: "", searchInternalPoc: "", category: "" });

  const fetchData = async () => {
    setBuffer(true);
    try {
      const res = await axios.get(listApiUrl);
      setData(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setBuffer(false);
    }
  };

  useEffect(() => { fetchData(); }, []);

  useEffect(() => {
    let result = data;
    if (filters.searchPartner) {
      const q = filters.searchPartner.toLowerCase();
      result = result.filter(r => r.partner_name?.toString().toLowerCase().includes(q));
    }
    if (filters.searchInternalPoc) {
      result = result.filter(r => r.internal_poc === filters.searchInternalPoc);
    }
    if (filters.category) {
      result = result.filter(r => {
        const s = r.sector;
        if (Array.isArray(s)) return s.some(x => x.toLowerCase() === filters.category.toLowerCase());
        if (typeof s === "string") return s.toLowerCase() === filters.category.toLowerCase();
        return false;
      });
    }
    setFilteredData(result);
  }, [filters, data]);

  const handleChange = (e) => setFilters(prev => ({ ...prev, [e.target.name]: e.target.value }));
  const handleClear = () => setFilters({ searchPartner: "", searchInternalPoc: "", category: "" });

  const renderSectors = (sector) => {
    const arr = Array.isArray(sector) ? sector : (typeof sector === "string" && sector ? [sector] : []);
    return arr.map((s, i) => <span key={i} style={S.sectorBadge}>{s}</span>);
  };

  return (
    <div style={S.root}>
      {/* Top bar */}
      <div style={S.topbar}>
        <span style={S.topbarBrand}>{title}</span>
        <div style={S.topbarActions}>
          <AddPartnerModal title={title} apiUrl={addApiUrl} getJvPartner={fetchData} JvPartnerData={data} />
          <UploadPartnerModal title={title} apiUrl={uploadApiUrl} getJvPartner={fetchData} />
        </div>
      </div>

      {/* Filter bar */}
      <div style={S.filterbar}>
        <div style={S.filterGroup}>
          <span style={S.filterLabel}>Partner Name</span>
          <input
            name="searchPartner"
            value={filters.searchPartner}
            onChange={handleChange}
            placeholder="Search partner…"
            style={S.filterInput}
          />
        </div>
        <div style={S.filterGroup}>
          <span style={S.filterLabel}>Internal POC</span>
          <input
            name="searchInternalPoc"
            value={filters.searchInternalPoc}
            onChange={handleChange}
            placeholder="Search internal POC…"
            style={S.filterInput}
          />
        </div>
        <div style={S.filterGroup}>
          <span style={S.filterLabel}>Sector</span>
          <select name="category" value={filters.category} onChange={handleChange} style={S.filterSelect}>
            <option value="">All Sectors</option>
            {sectorOptions.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>
        <div style={S.filterActions}>
          <button style={S.filterBtn(false)} onClick={handleClear}>Clear</button>
        </div>
        <span style={{ fontSize: "10.5px", color: "#57606a", marginLeft: "4px", alignSelf: "flex-end", paddingBottom: "2px" }}>
          Showing <strong style={{ color: "#185fa5" }}>{filteredData.length}</strong> of <strong style={{ color: "#185fa5" }}>{data.length}</strong>
        </span>
      </div>

      {/* Table */}
      <div style={S.tableScroll}>
        <table style={S.table}>
          <colgroup>
            <col style={{ width: "60px" }} />
            <col style={{ width: "40px" }} />
            <col style={{ width: "160px" }} />
            <col style={{ width: "120px" }} />
            <col style={{ width: "80px" }} />
            <col style={{ width: "160px" }} />
            <col style={{ width: "100px" }} />
            <col style={{ width: "130px" }} />
            <col style={{ width: "100px" }} />
            <col style={{ width: "130px" }} />
            <col style={{ width: "130px" }} />
            <col style={{ width: "130px" }} />
            <col style={{ width: "80px" }} />
          </colgroup>
          <thead>
            <tr>
              <th style={S.th(true)}>#</th>
              <th style={S.th(false)}>Priority</th>
              <th style={S.th(false)}>Partner Name</th>
              <th style={S.th(true)}>Sector</th>
              <th style={S.th(true)}>Ops POC</th>
              <th style={S.th(false)}>Email</th>
              <th style={S.th(true)}>Contact</th>
              <th style={S.th(false)}>Senior POC</th>
              <th style={S.th(true)}>Sr. Contact</th>
              <th style={S.th(false)}>Internal POC</th>
              <th style={S.th(false)}>TnCs</th>
              <th style={S.th(false)}>Remark</th>
              <th style={{ ...S.th(true), borderRight: "none" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {buffer ? (
              <tr>
                <td colSpan={13} style={S.emptyRow}>
                  <AimantraLoading />
                </td>
              </tr>
            ) : filteredData.length === 0 ? (
              <tr><td colSpan={13} style={S.emptyRow}>No records found.</td></tr>
            ) : (
              filteredData.map((row, idx) => (
                <tr
                  key={row.id || idx}
                  style={S.row(idx % 2 === 0)}
                  onMouseEnter={e => (e.currentTarget.style.background = "#f0f6ff")}
                  onMouseLeave={e => (e.currentTarget.style.background = idx % 2 === 0 ? "#f8fafd" : "#ffffff")}
                >
                  <td style={{ ...S.td(true), color: "#185fa5", fontWeight: 700, fontSize: "10.5px" }}>{idx + 1}</td>
                  <td style={S.td(true)}>{row.priority_order || "—"}</td>
                  <td style={{ ...S.td(false), fontWeight: 600 }}>{row.partner_name}</td>
                  <td style={{ ...S.td(true) }}>{renderSectors(row.sector)}</td>
                  <td style={S.td(true)}>{row.ops_poc || "—"}</td>
                  <td style={{ ...S.td(false), fontSize: "10.5px" }}>{row.email || "—"}</td>
                  <td style={S.td(true)}>{row.contact_no || "—"}</td>
                  <td style={S.td(false)}>{row.senior_poc || "—"}</td>
                  <td style={S.td(true)}>{row.senior_contact_no || row.senior_contact || "—"}</td>
                  <td style={S.td(false)}>{row.internal_poc || "—"}</td>
                  <td style={{ ...S.td(false), fontSize: "10.5px", maxWidth: "130px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={row.tncs}>{row.tncs || "—"}</td>
                  <td style={{ ...S.td(false), fontSize: "10.5px", maxWidth: "130px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={row.remark}>{row.remark || "—"}</td>
                  <td style={{ ...S.td(true), borderRight: "none" }}>
                    <div style={S.rowActions}>
                      <UpdatePartnerModal title={title} apiUrl={updateApiUrl} i={row} getJvPartner={fetchData} />
                      <DeletePartnerModal title={title} apiUrl={deleteApiUrl} i={row} getJvPartner={fetchData} />
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Status bar */}
      <div style={S.statusbar}>
        <span><strong>{filteredData.length}</strong> partners</span>
        <span style={{ opacity: 0.4 }}>|</span>
        <span>Total: <strong>{data.length}</strong></span>
      </div>

      <ToastContainer position="top-center" autoClose={1000} />
    </div>
  );
};

// ─── Main export ───────────────────────────────────────────────────────────────
const PartnerManagement = () => {
  const [toggleState, setToggleState] = useState(1);

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      {/* Tab bar */}
      <div style={S.tabbar}>
        {[
          { id: 1, label: "JV Partner" },
          { id: 2, label: "Associate Partner" },
        ].map(t => (
          <button key={t.id} style={S.tab(toggleState === t.id)} onClick={() => setToggleState(t.id)}>
            {t.label}
          </button>
        ))}
      </div>

      {/* Tab content */}
      <div style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" }}>
        {toggleState === 1 && (
          <PartnerTable
            title="JV Partner"
            listApiUrl={`${BASE_URL}/siteproject/jvpartnerbd/`}
            addApiUrl={`${BASE_URL}/siteproject/jvpartnerbd/`}
            updateApiUrl={`${BASE_URL}/siteproject/jvpartnerbd/`}
            deleteApiUrl={`${BASE_URL}/siteproject/jvpartnerbd/`}
            uploadApiUrl={`${BASE_URL}/siteproject/jvpartnerbulk/`}
            sectorOptions={["Highway", "Railway", "Metro", "Water", "Ropeway", "Building"]}
          />
        )}
        {toggleState === 2 && (
          <PartnerTable
            title="Associate Partner"
            listApiUrl={`${BASE_URL}/siteproject/associatepartner/`}
            addApiUrl={`${BASE_URL}/siteproject/associatepartner/`}
            updateApiUrl={`${BASE_URL}/siteproject/associatepartner/`}
            deleteApiUrl={`${BASE_URL}/siteproject/associatepartner/`}
            uploadApiUrl={`${BASE_URL}/siteproject/associatepartnerbulk/`}
            sectorOptions={["Highway", "Railway", "Water", "Metro", "Urban Infrastructure Buildings"]}
          />
        )}
      </div>
    </div>
  );
};

export default PartnerManagement;